<template>
  <div ref="appContainer">
    <Header :style="{ 'padding-top': `${headerHeight}px` }"></Header>
    <Hero
        title="Find the best buy-to-let mortgage deals"
        leading="Got your eyes on a great buy-to-let property? Our expert team gets to the heart of what you need, cutting out the hassles and headaches so you can get to the best deal fast."
        :points="[
            'We ﬁnd you the best buy-to-let mortgage deal from our panel of top lenders',
            'Cut your monthly payments or free up funds',
            'Our bespoke technology makes everything easy',
            'Whether you’re experienced or a beginner, we can help',
            'Access to exclusive offers'
            ]"
    />
    <TrustPilot />
    <InfoSection
        image="family-alt"
        title="Buy-to-let mortgages made simple."
        leading="We make it quick and easy to ﬁnd the right mortgage, and our
        application process is straightforward and simple."
        :points="[
            'Remortgages from £50,000 to £10,000,000',
            'No up front fees',
            'Access to exclusive offers',
            'As a leading Credit Broker and not a lender we search a panel of lenders',
            '5 Star customer service awarded by our customers'
            ]"
        :counter="true"
        :swap="true"
    />

    <InfoSection
        image="searching-alt"
        title="We work hard - you get the best deal."
    >
      <p class="font-weight-bold mt-3">
        Because we’re a credit broker, not a lender, we’re able to search a panel of leading
        lenders to find the mortgage deal that suits you best.
      </p>
      <p>Got a less-than-perfect credit history? No need to worry.</p>
      <p>Got CCJs or defaults? The chances are, we’ll still be able to help.</p>
      <p>Even if you’ve been made bankrupt,  Believe could still help get your ﬁnances back on track.</p>
    </InfoSection>
    <HowItWorks/>
    <Contact />
    <!--<Lenders />-->
    <Footer />
  </div>
</template>

<script>
import { Bus } from '../bus'

import Header from '../Sections/Header.vue'
import Hero from '../Sections/Hero.vue'
import TrustPilot from '../Sections/TrustPilot.vue'
import InfoSection from "../Sections/InfoSection";
import Contact from '../Sections/Contact.vue'
//import Lenders from '../Sections/Lenders.vue'
import Footer from '../Sections/Footer.vue'
import HowItWorks from "../Sections/HowItWorks";

export default {
  name: 'app',
  components: {
    HowItWorks,
    InfoSection,
    Header,
    Hero,
    TrustPilot,
    Contact,
    //Lenders,
    Footer
  },
  data() {
    return {
      height: 0
    }
  },
  computed: {
    headerHeight() {
      return this.height;
    }
  },
  created() {
    Bus.$on("headerHeight", (height) => {
      this.height = height;
    });
  },
  mounted() {
    window.addEventListener("message", event => {
      if (event.data.type === "scroll") {
        const iframePosition = document.getElementsByTagName('iframe')[0].getBoundingClientRect();
        event.data.offset -= this.height;
        if (event.data.offset < 0) {
          window.scrollTo(iframePosition.left, this.height);
          return;
        }
        const newScrollY =
            iframePosition.top + event.data.offset + window.scrollY;
        if (newScrollY < window.scrollY) {
          window.scrollTo(iframePosition.left, newScrollY);
        }
      }
    });
  }
}
</script>
